import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";

import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";

import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";

import { values } from "lodash";

import { HealthSurveillanceSectionProps } from "../models";
import * as questionIds from "../questions/questionIds";

import { MultiButtonQuestion } from "../../questionnaires/components/questions/MultiButtonQuestion";
import { getAnswerToQuestionWithId } from "../../questionnaires/getAnswerToQuestionWithId";

import { TextQuestion } from "../../questionnaires/components/questions/TextQuestion";
import { sections } from "../questionnaire";

const HealthSurveillanceMedicalQuestionsSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> =
    (props: HealthSurveillanceSectionProps) => {
        const supplyMedicalThroughText =  (getAnswerToQuestionWithId(values(props.questions || {}),
            questionIds.HideEmployeeQuestionsAndRecordMedicalSeparately) === MultiButtonQuestion.YesOption);

        const considerYourselfInGoodHealth = getAnswerToQuestionWithId(values(props.questions || {}),
            questionIds.ConsiderYourselfGoodHealth) === MultiButtonQuestion.NoOption;

        return (
            <OldProgressBarQuestionnaireSectionUnconnected
                {...props}
                {...sections.MedicalQuestions}
            >
                { props.recordMedicalsSeparately &&
                    <MultiButtonQuestion questionConfig={getQuestionConfig(
                        props.questionConfigs,
                        questionIds.HideEmployeeQuestionsAndRecordMedicalSeparately)}
                    readonly={props.readonly} />
                }

                { supplyMedicalThroughText &&
                    <TextQuestion
                        questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MedicalHistoryDetails)}
                        readonly={props.readonly}
                        mandatory={true}
                        multiline={true} />
                }

                {!supplyMedicalThroughText &&
                    <MultiButtonQuestion
                        questionConfig={getQuestionConfig(props.questionConfigs, questionIds.ConsiderYourselfGoodHealth)}
                        readonly={props.readonly} />
                }

                {!supplyMedicalThroughText && considerYourselfInGoodHealth &&
                    <TextQuestion
                        questionConfig={getQuestionConfig(props.questionConfigs, questionIds.ConsiderYourselfGoodHealthFurtherDetails)}
                        readonly={props.readonly} />
                }
                {!supplyMedicalThroughText && YesNoWithFollowUpQuestion({
                    questionConfigs: [
                        getQuestionConfig(props.questionConfigs, questionIds.ReceivingAnyFormMedicalTreatment),
                        getQuestionConfig(props.questionConfigs, questionIds.ReceivingAnyFormMedicalTreatmentFurtherDetails)
                    ],
                    readonly: props.readonly,
                    questions: props.questions
                })}
                {!supplyMedicalThroughText && YesNoWithFollowUpQuestion({
                    questionConfigs: [
                        getQuestionConfig(props.questionConfigs, questionIds.TakingRegularMedication),
                        getQuestionConfig(props.questionConfigs, questionIds.TakingRegularMedicationFurtherDetails)
                    ],
                    readonly: props.readonly,
                    questions: props.questions
                })}
                {!supplyMedicalThroughText &&  YesNoWithFollowUpQuestion({
                    questionConfigs: [
                        getQuestionConfig(props.questionConfigs, questionIds.SufferFromDisabilityImpairment),
                        getQuestionConfig(props.questionConfigs, questionIds.SufferFromDisabilityImpairmentFurtherDetails)
                    ],
                    readonly: props.readonly,
                    questions: props.questions
                })}
                {!supplyMedicalThroughText && YesNoWithFollowUpQuestion({
                    questionConfigs: [
                        getQuestionConfig(props.questionConfigs, questionIds.ConditionAttentionOccupationalHealthTeam),
                        getQuestionConfig(props.questionConfigs, questionIds.ConditionAttentionOccupationalHealthTeamFurtherDetails)
                    ],
                    readonly: props.readonly,
                    questions: props.questions
                })}
            </OldProgressBarQuestionnaireSectionUnconnected>
        );
    };

// eslint-disable-next-line max-len
export const HealthSurveillanceMedicalQuestionsSection = connect(makeMapStateToQuestionnaireSectionProps(sections.MedicalQuestions.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceMedicalQuestionsSectionUnconnected);
